import beaconService from '../services/BeaconService'
import { getCitrusImpressionBeacon, getCitrusClickBeacon } from '../redux/citrus'

export function executeCitrusBeacon(citrus, onCitrusBeaconSent, payload, type) {
  const impressionBeacon = getCitrusImpressionBeacon(citrus, payload.productId)
  const clickBeacon = getCitrusClickBeacon(citrus, payload.productId)
  const { citrusBaseUrl } = window

  if (type === 'impBeacon' && impressionBeacon) {
    const beaconUrl = `${citrusBaseUrl}/v1/resource/first-i/${impressionBeacon}`
    if (navigator.sendBeacon) {
      navigator.sendBeacon(beaconUrl)
    } else {
      beaconService(beaconUrl)
    }
    onCitrusBeaconSent({
      productSku: payload.productId,
      beaconType: 'impression'
    })
  }
  if (type === 'clickBeacon' && clickBeacon) {
    const beaconUrl = `${citrusBaseUrl}/v1/resource/second-c/${clickBeacon}`
    if (navigator.sendBeacon) {
      navigator.sendBeacon(beaconUrl)
    } else {
      beaconService(beaconUrl)
    }
    onCitrusBeaconSent({
      productSku: payload.productId,
      beaconType: 'click'
    })
  }
}
